// extracted by mini-css-extract-plugin
export default {"dialog_content":"deleteConfirm_dialog_content__wMvNe"};